import { Action } from "redux";
import { TrackingProfile, syncTrackersToLocalStorage } from "../../lib/accountUtils";
import { m } from '../../lib/selectorUtils';
import { createThunk } from "../../lib/storeUtils";
import { TrackingDataState } from "../reducers/trackingData";
import { trackingDataSelector } from "../selectors";

export const LOAD_TRACKINGDATA = 'TRACKINGDATA/LOAD';

export interface LoadTrackingDataActionPayload {
  email: TrackingDataState['email'];
  firstname: TrackingDataState['firstname'];
  lastname: TrackingDataState['lastname'];
  initialinterest: TrackingDataState['initialinterest'];
  lastupdated: TrackingDataState['lastupdated'];
}
export interface LoadTrackingDataAction extends Action {
  payload: Promise<TrackingProfile>;
}

export const loadTrackingDataThunk = m(createThunk(
  trackingDataSelector,
  (): LoadTrackingDataAction => ({
    type: LOAD_TRACKINGDATA,
    payload: syncTrackersToLocalStorage().then((trackingData): TrackingProfile => ({...trackingData}))
  })
));